/**
 * Configración de la constante de BUSINESS_CONST
 *
 * *Constant BUSINESS_CONST configuration*
 */
export const SEGMENTS_CONST = {
  SUCURSAL: '335',
  PB: '315',
};

export const RISK_LEVELS = {
  VERYLOW: 'LO',
  LOW: 'ML',
  MEDIUM: 'ME',
  HIGH: 'HI',
  NORISK: 'UN',
};
